import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const complianceErrorTypeValues = ["UNKNOWN", "CONTRACTOR_NOT_FOUND"] as const;
const complianceErrorTypeSchema = z.enum(complianceErrorTypeValues);
const ComplianceErrorType = complianceErrorTypeSchema.enum;
type ComplianceErrorType = z.infer<typeof complianceErrorTypeSchema>;

export type ComplianceErrors =
  | { errorType: typeof ComplianceErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof ComplianceErrorType.CONTRACTOR_NOT_FOUND; data: { projectId: number } };

export const complianceErrorDetails: Record<ComplianceErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  CONTRACTOR_NOT_FOUND: {
    classification: ErrorClassification.NOT_FOUND_ERROR,
    sentryDescription: "Contractor not found",
  },
};
